import { Box, Grid, Skeleton } from '@mui/material'
import React from 'react'

/**
 * old SpaceUsageLoader
 * @constructor
 * @deprecated
 */
const SpaceUsageLoader = () => {
    return (
        <Box sx={{
            boxShadow: '0px 0px 0px 1px #E0E0E0',
            p: 1.5,
            borderRadius: '0.4em',
            position: 'relative',
        }}>
            <Grid spacing={2} container>
                {
                    Array.from({ length: 12 }).map((_, index) => (
                        <Grid key={index} xs={12} sm={6} md={2} item>
                            <Skeleton variant="rectangular" width="100%" />
                            <Skeleton variant="text" width="90%" />
                        </Grid>
                    ))
                }
            </Grid>
        </Box>
    )
}

export default SpaceUsageLoader